import React from 'react';
import './TabsMod.scss';

const TabsMod = () => {
  return (
    <div className="main-right-side-section">
      <div className="ngtabs-main-section">
        <section>
          <div className="ngtabs-section-1">
            <div className="ngtabs-section-1-inner">
              <p>Tabs Module</p>
            </div>
          </div>
        </section>
      </div>
    </div>
  )
}

TabsMod.propTypes = {};

TabsMod.defaultProps = {};

export default TabsMod;
